export default __webpack_public_path__ + "5d830e49fcc60579992997c08206b10c.png";